var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "defaultOfficeSelection-modal",
        width: "100%",
        adaptive: true,
        height: "auto",
        "max-width": 700,
        clickToClose: false,
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "container modal--container" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-wrap justify-content-between mb-2" },
          [_c("h1", [_vm._v(_vm._s("Select default office"))])]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column flex-wrap" }, [
          _c("span", [
            _vm._v(
              "\n        You have been added to\n        " +
                _vm._s(
                  _vm.filteredEmployees.length > 0 &&
                    _vm.filteredEmployees[0].attributes.organization_name
                ) +
                "\n        hungerhub account. Please ensure you are ordering under the correct\n        account when placing your order. To change office profiles, select\n        your name in the top right corner. To remove an office from your\n        account, visit your profile page or start a chat. Which account would\n        you like to login to now\n      "
            )
          ]),
          _vm._v(" "),
          _vm.employee && _vm.filteredEmployees.length >= 1
            ? _c(
                "div",
                { staticClass: "d-flex flex-column mt-3" },
                [
                  _vm._l(_vm.filteredEmployees, function(emp, index) {
                    return _c(
                      "button",
                      {
                        key: emp.id,
                        class: {
                          "dropdown-item pl-0": true,
                          "office-button-pad": index > 0
                        },
                        on: {
                          click: function($event) {
                            return _vm.setOrganization(emp)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "text-left" }, [
                          _vm._v(
                            _vm._s(emp && emp.attributes.organization_name)
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("hr")
                ],
                2
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-657dc13e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657dc13e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DefaultOfficeSelectionModal.vue
// module id = null
// module chunks = 